module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/ko/2-d08bbebdbf3d15fe8afbf3d1200edf0d.jpg";